﻿<template>
    <div class="bd-guest" :class="{ 'is-lead': Lead_Passenger() }">
        <span class="bd-avatar" aria-hidden="true">{{ Initials() }}</span>
        <div class="min-w-0 flex-1">
            <div class="bd-guest-name">
                {{ pax?.first_name }} {{ pax?.family_name }}
                <span v-if="Lead_Passenger()" class="mb-pill is-accent no-dot">Lead guest</span>
            </div>
            <dl v-if="Lead_Passenger()" class="bd-guest-contact">
                <div>
                    <dt>Email</dt>
                    <dd><a v-if="pax?.email" :href="'mailto:' + pax.email">{{ pax.email }}</a><span v-else>—</span></dd>
                </div>
                <div>
                    <dt>Phone</dt>
                    <dd><a v-if="pax?.telephone_number" :href="'tel:' + pax.telephone_number">{{ pax.telephone_number }}</a><span v-else>—</span></dd>
                </div>
                <div>
                    <dt>Postcode</dt>
                    <dd>{{ pax?.post_code || '—' }}</dd>
                </div>
            </dl>
        </div>
    </div>
</template>

<script lang="ts" src="./passenger.ts"></script>